import React, { useEffect } from 'react';
import { useAnalytics, AnalyticsContextProvider } from '@growth/use-analytics';
import { isOnClient } from '@growth/ssr-utils';
import { s as sendPdtEvent, _ as _extends, i as initOmnitureAnalytics } from '../../dist/omniture-4e08e7dc.esm.js';
import { _ as _taggedTemplateLiteralLoose } from '../../dist/taggedTemplateLiteralLoose-7a042257.esm.js';
import styled from 'styled-components';
import { textSizes, breakPoints } from '@growth/design-system';
import '@growth/pdt-push';
import '@growth/analytics-plugin-adobe';
import '@growth/auth-helpers';
import '@growth/web-analytics';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var ReviewGoTribeWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\tpadding: 12px;\n\tborder-bottom-left-radius: 10px;\n\tborder-bottom-right-radius: 10px;\n\tgap: 8px;\n\tbackground: white;\n\tdisplay: flex;\n\talign-items: center;\n\t.goTribeText {\n\t\t", "\n\t\tcolor: #000000;\n\t}\n\n\t@media (max-width: ", ") {\n\t\tpadding: 10px;\n\t}\n"])), textSizes.BaseW1, breakPoints.mobileM);
var GoTribeText = styled.p(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #000000;\n"])), textSizes.BaseW1);
var GoTribeIconWrapper = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n\tflex-shrink: 0;\n"])));
var Heading = styled.h5(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n\tborder-top-left-radius: 10px;\n\tborder-top-right-radius: 10px;\n\t", "\n\tbackground: linear-gradient(315deg, rgba(255, 255, 255, 0) 0%, #FFECE5 100%);\n\tborder-bottom: 2px solid #ffece5;\n\tpadding: 12px;\n\n\t@media (max-width: ", ") {\n\t\tpadding: 10px;\n\t}\n"])), textSizes.MediumW3, breakPoints.mobileM);
var Wrapper = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\tbackground: #fff;\n\toverflow: hidden;\n\tborder-radius: 12px;\n"])));
var TribeIcon = styled.img(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n    height: 20px;\n"])));

var GoTribeSideStripInner = function GoTribeSideStripInner(_ref) {
  var lob = _ref.lob,
    image = _ref.image,
    text = _ref.text,
    heading = _ref.heading,
    onLoad = _ref.onLoad,
    _ref$customStyle = _ref.customStyle,
    customStyle = _ref$customStyle === void 0 ? {} : _ref$customStyle;
  var pageName = lob + "_page";
  var _useAnalytics = useAnalytics(),
    adobe = _useAnalytics.adobe;
  useEffect(function () {
    adobe.track('ctaClick', {
      cta: {
        name: 'GI_GOTRIBE_LOB_BOTTOMSTRIP_REVIEW',
        type: "itemLoaded | " + lob + "_Review",
        componentName: 'GI_GOTRIBE_LOB_BOTTOMSTRIP_REVIEW'
      }
    });
    sendPdtEvent({
      eventName: "gotribe_lob_bottomstrip_review_screenLoad",
      contentId: 'GI_GOTRIBE_LOB_BOTTOMSTRIP_REVIEW',
      contentCategoryName: lob + "_Review",
      pageName: pageName
    });
    onLoad == null || onLoad();
  }, []);
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: "gi_gotribe_side_strip_wrapper",
    style: _extends({}, customStyle)
  }, /*#__PURE__*/React.createElement(Heading, null, heading), /*#__PURE__*/React.createElement(ReviewGoTribeWrapper, {
    className: "gi_gotribe_side_strip"
  }, /*#__PURE__*/React.createElement(GoTribeIconWrapper, null, /*#__PURE__*/React.createElement(TribeIcon, {
    src: image,
    alt: "gotribe"
  })), /*#__PURE__*/React.createElement(GoTribeText, {
    dangerouslySetInnerHTML: {
      __html: text
    }
  })));
};

var GoTribeSideStrip = function GoTribeSideStrip(_ref) {
  var lob = _ref.lob,
    image = _ref.image,
    text = _ref.text,
    heading = _ref.heading,
    onLoad = _ref.onLoad,
    _ref$customStyle = _ref.customStyle,
    customStyle = _ref$customStyle === void 0 ? {} : _ref$customStyle,
    device = _ref.device;
  var adobe = isOnClient ? initOmnitureAnalytics({
    lobName: lob,
    debug: false,
    flavour: device || 'mweb'
  }) : undefined;
  return /*#__PURE__*/React.createElement(AnalyticsContextProvider, {
    adobeInstance: adobe
  }, /*#__PURE__*/React.createElement(GoTribeSideStripInner, {
    lob: lob,
    image: image,
    text: text,
    heading: heading,
    onLoad: onLoad,
    customStyle: customStyle
  }));
};
GoTribeSideStrip.defaultProps = {
  device: 'mweb',
  onLoad: undefined,
  customStyle: undefined
};

export { GoTribeSideStrip };
